module.exports = __webpack_public_path__ + "img/optioninfo.41f3e887.jpg";